export const KIWI_FRAME = `${process.env.REACT_APP_KIWI_FRAME}`;
export const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/ops/`;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const OAUTH2_REDIRECT_URI = process.env.REACT_APP_OAUTH2_REDIRECT_URI;

export const GOOGLE_AUTH_URL = `${AUTH_BASE_URL}/login?client_id=${process.env.REACT_APP_OAUTH_CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=${OAUTH2_REDIRECT_URI}`;
export const GENERATE_TOKENS_URL = `${AUTH_BASE_URL}/oauth2/token`;
